import { render, staticRenderFns } from "./UserMoreItem.vue?vue&type=template&id=c3f5edfe&scoped=true&"
import script from "./UserMoreItem.vue?vue&type=script&lang=ts&"
export * from "./UserMoreItem.vue?vue&type=script&lang=ts&"
import style0 from "./UserMoreItem.vue?vue&type=style&index=0&id=c3f5edfe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3f5edfe",
  null
  
)

export default component.exports